import { Backdrop, Box } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/EditOutlined";
import { useMutateForm } from "api/useMutateForm";
import { useSimpleModalToggle } from "components/dialogs/useSimpleModal";
import { AddProductArticle } from "components/ProductArticles/AddProductArticle";
import React from "react";
import { FormWithRedirect, useRefresh, useTranslate } from "react-admin";

import { AddEditOrderProductArticleFieldBody } from "./AddEditOrderProductArticleFieldBody";

export const UpdateOrderProductArticle = ({
	orderProductArticle,
	companyId,
	productArticleReloadKey,
	setProductArticleReloadKey,
	isColdStorageService,
	totalBoxes,
	allOrderProductArticles,
	disableEdit = false,
	allowEditOnlyDate = false,
	...props
}) => {
	const { open, handleOpen, handleClose } = useSimpleModalToggle();
	const refresh = useRefresh();
	const translate = useTranslate();

	const [handleSubmit, { loading }] = useMutateForm(
		"update",
		"order-product-articles",
		null,
		orderProductArticle.id,
		{},
		() => {
			handleClose();
			refresh();
			return true;
		},
		undefined,
		translate("osfc.dialogs.order-product-articles.update.success")
	);

	return (
		<>
			<IconButton
				aria-label="edit"
				size="small"
				color="default"
				onClick={handleOpen}
				disabled={disableEdit}
			>
				<EditIcon color={disableEdit ? "disabled" : "primary"} />
			</IconButton>
			{open && (
				<Dialog open={true} onClose={handleClose} maxWidth="md">
					<DialogTitle>
						<Box display="flex" justifyContent="space-between" alignItems="center">
							<span>
								{translate("resources.order-product-articles.edit.title")} {orderProductArticle.id}
							</span>
							{isColdStorageService && (
								<AddProductArticle
									companyId={companyId}
									createButton={
										<Button
											size="small"
											variant="contained"
											color="primary"
											startIcon={<AddIcon />}
										>
											{translate("resources.product-articles.add-product-articles")}
										</Button>
									}
									isNeedRefresh={false}
									onCreated={() => setProductArticleReloadKey((prev) => prev + 1)}
								/>
							)}
						</Box>
					</DialogTitle>
					<Box position="relative">
						<FormWithRedirect
							record={orderProductArticle}
							submitOnEnter={false}
							component={DialogContent}
							save={handleSubmit}
							render={({ handleSubmitWithRedirect, form, record }) => (
								<React.Fragment>
									<AddEditOrderProductArticleFieldBody
										form={form}
										companyId={companyId}
										record={record}
										productArticleReloadKey={productArticleReloadKey}
										isColdStorageService={isColdStorageService}
										totalBoxes={totalBoxes}
										allOrderProductArticles={allOrderProductArticles}
										isAddMode={false}
										disableEdit={disableEdit}
										allowEditOnlyDate={allowEditOnlyDate}
									/>
									<DialogActions>
										<Button disabled={loading} onClick={handleClose} color="primary">
											{translate("ra.action.cancel")}
										</Button>
										<Button disabled={loading} onClick={handleSubmitWithRedirect} color="primary">
											{translate("ra.action.update")}
										</Button>
									</DialogActions>
								</React.Fragment>
							)}
						/>
						<Backdrop
							open={loading}
							style={{
								position: "absolute",
								zIndex: 1000,
								backgroundColor: "rgba(255, 255, 255, 0.7)",
							}}
						>
							<CircularProgress />
						</Backdrop>
					</Box>
				</Dialog>
			)}
		</>
	);
};
